import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import Checkbox from 'components/checkbox/Checkbox';

import './WeighInSheet.scss';

import {
  getSessionOptions,
  getPlatformOptions
} from 'util/options';
import { getCurrentMeet } from 'selectors';

const WeighInTable = ({session, meet, lifters, platform}) => {
  return (
    <div className="session-pages">
      <div className="meet-name">{meet.date} - {meet.name} - Session {session.value} {platform ? `- Platform ${platform.label} ` : ''}- WEIGH IN ORDER</div>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Platform</th>
            <th>Flight</th>
            <th>Lot #</th>
            <th>Name</th>
            <th>Team</th>
          </tr>
        </thead>
        <tbody>
          {
            _.map(lifters, (lifter, index) => {
              return (
                <tr key={lifter._id}>
                  <td>{index + 1}</td>
                  <td>{_.get(meet, ['platforms', lifter.platformId, 'name'])}</td>
                  <td>{lifter.flight}</td>
                  <td>{lifter.lot}</td>
                  <td>{lifter.name}</td>
                  <td>{lifter.team}</td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};

class WeighInSheet extends Component {
  constructor(props) {
    super(props);
    this.state = {groupByPlatform: false};
  }

  render() {
    const { meet } = this.props;

    const lifters = _.sortBy(meet.lifters, ['lot']);

    return (
      <div className="weigh-in-sheet">
        <div className="weigh-in-sheet-options">
          <Checkbox label="Group By Platform" value={this.state.groupByPlatform} onCheck={(v)=> this.setState({groupByPlatform: v})} />
        </div>
        {
          _.map(getSessionOptions(), (session) => {
            const sessionLifters = _.filter(lifters, {session: session.value});
            const sessionCount = _.size(sessionLifters);
            if(!sessionCount) {
              return null;
            }

            if(this.state.groupByPlatform) {
              return _.map(getPlatformOptions({}, meet), (platform) => {
                const platformLifters = _.filter(sessionLifters, {platformId: platform.value});
                const platformCount = _.size(platformLifters);
                if(!platformCount) {
                  return null;
                }
                return <WeighInTable key={platform.value} session={session} meet={meet} lifters={platformLifters} platform={platform}/>;
              });
            }

            return <WeighInTable key={session.value} session={session} meet={meet} lifters={sessionLifters}/>;
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(WeighInSheet);
